export function setModel(state, data) {
  state.model = data;
}
export function setB1(state, data) {
  state.b1 = data;
}
export function setBank(state, data) {
  state.bank = data;
}
